import { WEB_CHAT_DEBOUNCE_MS } from "@repo/common/expert-agent-chat";

/**
 * Whether to draw the typing indicator.
 *
 * False for the length of the server's debounce window, because during it the
 * agent has not been handed the turn: the message is still gathering, and
 * another line can join it. Dots there would announce an answer to a thought
 * the reader may still be finishing -- and, worse, nudge them to stop.
 *
 * The sent message is drawn immediately regardless. That is what covers the
 * wait; the indicator is a claim about the other side, not a receipt.
 */
export function agentIsTyping(
  awaitingSince: number | null,
  now: number,
): boolean {
  if (awaitingSince === null) {
    return false;
  }
  return now - awaitingSince >= WEB_CHAT_DEBOUNCE_MS;
}
